/** @format */

import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconMediaPlayFill,
} from '@dsg-tech/homefield-angular-icons';

@Component({
  selector: 'common-components-play-button',
  templateUrl: './play-button.component.html',
  styleUrl: './play-button.component.scss',
  imports: [HomefieldIconLibraryModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayButtonComponent {
  homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
  isLarge = input(false);
  // Default look is a dark circle with a light icon. When true, swaps to a
  // light circle with a dark icon instead (e.g. overlaying imagery where the
  // default dark treatment doesn't read well).
  invertColors = input(false);

  iconSize = { small: '24px', large: '40px' };

  readonly iconFill = computed(() =>
    this.invertColors() ? 'var(--hmf-background-inverse)' : 'var(--hmf-background-base)',
  );

  constructor() {
    this.homefieldIconsLibraryService.registerIcons([homefieldIconMediaPlayFill]);
  }
}
